
import { assessmentHasImagesOrComments } from '@/shared/helpers';
import globalConstants from '../../shared/globalConstants';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import TrailerAssessment from '../../types/TrailerAssessment';
import TrailerAssessmentType from '../../types/TrailerAssessmentType';
import TrailerDamageLayout from './TrailerDamageLayout.vue';

export default defineComponent({
    components: { TrailerDamageLayout },
    data(): {
        type: keyof TrailerAssessment;
        subTypes: {
            leftAirline: string;
            sevenWay: string;
            rightAirline: string;
            lowerAirlineElectrical: string;
        };
        typeAssessment: TrailerAssessmentType | undefined;
    } {
        return {
            type: globalConstants.trailer.assessmentTypes
                .airlinesElectrical as keyof TrailerAssessment,
            subTypes: {
                leftAirline:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .leftAirline,
                sevenWay:
                    globalConstants.trailer.assessmentTypes.subTypes.sevenWay,
                rightAirline:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .rightAirline,
                lowerAirlineElectrical:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .lowerAirlineElectrical,
            },
            typeAssessment: undefined,
        };
    },
    computed: {
        ...mapGetters({ trailerAssessment: 'trailerAssessment' }),
        leftAirlineButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.leftAirline
            )
                ? 'active'
                : '';
        },
        sevenWayButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.sevenWay
            )
                ? 'active'
                : '';
        },
        rightAirlineButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.rightAirline
            )
                ? 'active'
                : '';
        },
        lowerAirlineElectricalButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.lowerAirlineElectrical
            )
                ? 'active'
                : '';
        },
    },
    created() {
        if (this.trailerAssessment)
            this.typeAssessment = this.trailerAssessment[this.type];
    },
    methods: {
        leftAirlineTapped(): void {
            this.$router.push({
                path: `airlinesAssessment/${this.subTypes.leftAirline}`,
            });
        },
        sevenWayTapped(): void {
            this.$router.push({
                path: `airlinesAssessment/${this.subTypes.sevenWay}`,
            });
        },
        rightAirlineTapped(): void {
            this.$router.push({
                path: `airlinesAssessment/${this.subTypes.rightAirline}`,
            });
        },
        lowerAirlineElectricalTapped(): void {
            this.$router.push({
                path: `airlinesAssessment/${this.subTypes.lowerAirlineElectrical}`,
            });
        },
    },
});
